import { gql } from "@apollo/client";

export const UploadFloorplanBackdropImageDocument = gql`
  mutation UploadFloorplanBackdropImage($floorplanId: ID!, $image: Upload!) {
    uploadFloorplanBackdropImage(floorplanId: $floorplanId, image: $image)
  }
`;

export const DeleteFloorplanBackdropImageDocument = gql`
  mutation DeleteFloorplanBackdropImage($floorplanId: ID!, $imageUrl: String!) {
    deleteFloorplanBackdropImage(floorplanId: $floorplanId, imageUrl: $imageUrl)
  }
`;
